import React, { useCallback, useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router'
import { PageLevelTableWrapper, Table, TableColumns, useTableReducer } from '@base'
import { strings, poStatus as OrderStatus, enquiryOrderFilter } from '@constants'
import { getAllSupplyOrder } from '@data'
import { displayAmount } from '@utils'
import { paths } from '@routes'

const SPOByStatus = () => {
	const navigate = useNavigate()
	const urlParams = useParams()
	const orderStatus = urlParams?.orderStatus
	const [state, dispatch, actions] = useTableReducer(enquiryOrderFilter)

	const getOrderTypesToFetch = useCallback(() => {
		switch (orderStatus) {
			case 'all':
				return [OrderStatus.active, OrderStatus.completed, OrderStatus.shortclosed]
			case 'active':
				return [OrderStatus.active]
			case 'completed':
				return [OrderStatus.completed, OrderStatus.shortclosed]
			// case 'cancelled':
			// 	return [OrderStatus.cancelled]
			// ACTIVE, ATTACHED, COMPLETED, SHORT_CLOSED
			default:
				return []
		}
	}, [orderStatus])
	useEffect(() => {
		if (state.loading) return

		dispatch(actions.fetchTableDataProgress())
		const types = getOrderTypesToFetch()
		getAllSupplyOrder(types)
			.then((response) => {
				dispatch(actions.fetchTableDataSuccess(response.data, response.count))
			})
			.catch((err) => dispatch(actions.fetchTableDataFailure(err)))
	}, [state.query, orderStatus])

	const columns = useMemo(
		() => [
			TableColumns.usernameColumn({ label: strings('supplier'), key: 'supplier', mobile: true, align: 'left' }),
			{
				label: strings('po', 'number'),
				key: 'supplier_po_number',
				align: 'center',
				mobile: true,
			},
			{
				label: strings('po', 'status'),
				key: 'supplier_po_status',
				align: 'center',
				mobile: true,
			},
			{
				label: strings('quote', 'type'),
				key: (row) => {
					return row?.quote_type
				},
				align: 'center',
			},
			{
				label: strings('total_quotation_amount'),
				key: (row) => {
					// if (isBitumen) return ''
					return displayAmount(row.order_items.reduce((total, item) => total + item.allotted_weight * item.price_per_kg, 0))
				},
				align: 'center',
			},
			{
				label: strings('logistics_quotation'),
				key: (row) => {
					let amount = ''
					if (row?.quote_type === strings('x')) {
						amount =
							row?.lumpsum_logistics_quote !== 0
								? { type: strings('lumpsum'), price: row?.lumpsum_logistics_quote }
								: { type: strings('cost/mt'), price: row?.logistics_quote_per_mt }
					}
					if (!amount) {
						return '-'
					}

					return (
						<>
							<div>
								<b>{displayAmount(amount?.price)}</b>
							</div>
							<div style={{ textTransform: 'uppercase' }}>
								<small>({amount?.type})</small>
							</div>
						</>
					)
				},
				mobile: false,
				align: 'center',
			},
			TableColumns.addressColumn({ key: 'dispatch_location', label: strings('dispatch_location'), align: 'center', mobile: true }),
		],
		[]
	)

	const changePageHandler = (next = true) => {
		dispatch(actions.changePage(next))
	}

	const rowClickHandler = (row) => {
		navigate(paths.admin_edit_spo(row.supplier_po_number))
	}

	return (
		<>
			<PageLevelTableWrapper>
				<Table
					fullHeight
					data={state.data}
					columns={columns}
					loading={state.loading}
					rowClickable={true}
					rowsToDisplay={10}
					totalItemCount={state.total_count}
					page={state.query.page}
					onPageChange={changePageHandler}
					onRowClick={rowClickHandler}
				/>
			</PageLevelTableWrapper>
		</>
	)
}

export default SPOByStatus
